<template>
<div class="newsDetail-wrap" v-if="newsDetail">
  <h2 class="title">{{newsDetail.Title}}</h2>
  <p class="source">
    <span>来源：{{newsDetail.Source}}</span>
    <span>{{newsDetail.Pubdate}}</span>
  </p>
  <div class="comment">
    <span>研究员点评</span>
    <span>
      星级评级：
      <strong class="star">
        <i v-for="(star, index) in 3" :key="index"
          :class="{active: index < Math.abs(newsDetail.Extra.star),yellow: newsDetail.Extra.star <0}"
          >
        </i>
      </strong>
    </span>
  </div>
  <div class="content" v-html="filtrationA(newsDetail.Content)"></div>
</div>
</template>

<script>
export default {
  data() {
    return {
      esId: '',
      newsDetail: '',
    }
  },
  mounted() {
    this.esId = this.$route.query.esId
    this.getNewsDetail()
  },
  methods: {
    // 获取新闻详情
    getNewsDetail () {
      this.$http({
        method: 'get',
        url:  window.config.newsDetail_server + '/docs/get',
        params: {
          id: this.esId,
        }
      }).then(res =>{
        if(res.data.ErrCode == 0) {
          this.newsDetail = res.data.Data.Docs[0]
        }
      })
    },
    //过滤A标签
    filtrationA (c){
      var content = c.replace(/href=\"@min=\w\w*([0-9]*)\" style=\"color:#(.{6});\"/g,"") //eslint-disable-line
      return content
    },
  },
}
</script>

<style lang="scss" scoped>
.newsDetail-wrap{
  padding: 0 0.16rem 0.2rem;
  .title{
    font-size: 0.22rem;
    color: #222;
    margin: 0.06rem 0 0.18rem;
  }
  .source{
    font-size: 0.12rem;
    color: #999;
    display: flex;
    align-items: center;
    line-height: 1;
    span{
      margin-right: 0.14rem;
    }
  }
  .comment{
    border-radius: 6px;
    background: #F8F8F8;
    padding: 0 0.08rem;
    height: 0.28rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.16rem 0 0.2rem;
    font-size: 0.12rem;
    color: #999;
    span{
      display: flex;
    }
  }
  .content{
    font-size: 0.18rem;
    color: #555;
    line-height: 0.29rem;
  }
}
.blackTheme {
  .newsDetail-wrap{
    .title{
      color: #E4E9FE;
    }
    .source{
      color: #6B7687
    }
    .comment{
      background: #242631;
      color: #6B7687
    }
    .content{
      color: #AAB9D1;
    }
  }
}
</style>
